import { Component, Input, OnInit } from '@angular/core';
import { GetChatDashboardStatsResponse } from '@projects/shared/src/app/features/chat/interfaces/dashboard/GetChatDashboardStatsResponse';

@Component({
  selector: 'app-chat-breakdown',
  templateUrl: './chat-breakdown-updated.component.html',
  styleUrls: ['./chat-breakdown.component.scss'],
})
export class ChatBreakdownComponent implements OnInit {
  @Input() data: GetChatDashboardStatsResponse | undefined;
  @Input() config: any;
  constructor() {}

  ngOnInit(): void {}
}
